import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getOrganisationIdFromToken } from "../utils/getUserDetails";

const usePaymentStatusCheck = () => {
    const [paymentStatus, setPaymentStatus] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const checkPaymentStatus = async () => {
            try {
                const organisationId = getOrganisationIdFromToken();
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/organisation/${organisationId}`
                );
                const data = await response.json();

                if (data.success) {
                    const { paymentStatus } = data.result;
                    setPaymentStatus(paymentStatus);
                }
            } catch (error) {
                console.error("Error:", error);
                // alert("An error occurred while fetching payment status.");
            }
        };

        checkPaymentStatus();
    }, [navigate]);

    return paymentStatus;
};

export default usePaymentStatusCheck;